import type { EntryPoint } from '@/apilib';
import { EditorAPIKey, PanelManagerApiKey } from '@/apis';
import { createPanelManagerApi } from './panelManagerApi';

export const PanelManagerApiEntryPoint: EntryPoint = {
  name: 'PanelManagerApi',
  declareAPIs: () => [PanelManagerApiKey],
  getDependencyAPIs: () => [EditorAPIKey],
  attach(shell) {
    shell.contributeAPI(PanelManagerApiKey, () => createPanelManagerApi(shell));
  },
};
